<template>
  <div>
    <div class="gap">
      <div class="title">
        <slot name="afterTitle">{{ afterTitle }}</slot>
      </div>
      <slot name="after"></slot>
    </div>
    <div class="gap">
      <div class="title">
        <slot name="beforeTitle">{{ beforeTitle }}</slot>
      </div>
      <slot name="before"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModifcationDetail',

  props: {
    afterTitle: {
      type: String,
      default: '修改后',
    },
    beforeTitle: {
      type: String,
      default: '修改前',
    },
  },
  computed: {},
  data() {
    return {
      value: '',
    }
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.gap {
  margin-bottom: 30px;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  text-align: center;
}
</style>
